module.exports = __webpack_public_path__ + "img/kiss.e5cf4ece.png";